import { SessionRecorder } from './recorder';
export { SessionRecorder };
// UMD consumers (script-tag, no bundler) get the instance as the global
// directly (window.SessionRecorder.init(...)) instead of having to type
// window.SessionRecorder.SessionRecorder.init(...).
export default SessionRecorder;
export type {
  RecorderConfig,
  SessionInfo,
  RecordedEvent,
  EventPayload,
  SessionPayload,
  PartialRecorderConfig,
  DevToolsData,
  DevToolsNetworkEvent,
  DevToolsConsoleLog,
  DevToolsPerformanceData,
  StateChangeEvent
} from './types';
